// 精确到小时
export function getDate(tm) {
  const now = new Date(tm)
  const y = now.getFullYear()
  const m = now.getMonth() + 1
  const d = now.getDate()
  const h = now.getMinutes()
  return y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d) + ' ' + (h < 10 ? '0' + h : h) + '时'
}

// 精确到天
export function getTimeToDate(time) {
  const now = new Date(time)
  const y = now.getFullYear()
  const m = now.getMonth() + 1
  const d = now.getDate()
  return y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d)
}

// 车牌号校验
export function isVehicleNumber(vehicleNumber) {
  var xreg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF]$)|([DF][A-HJ-NP-Z0-9][0-9]{4}$))/
  var creg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1}$/
  if (vehicleNumber.length == 7) {
    return creg.test(vehicleNumber)
  } else if (vehicleNumber.length == 8) {
    return xreg.test(vehicleNumber)
  } else {
    return false
  }
}

// 获取地址参数
function getUrlKey(name) {
  return (
    decodeURIComponent(
      (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(
        location.href
      ) || [null, ''])[1].replace(/\+/g, '%20')
    ) || null
  )
}

// 判断字符串是否为空
function isEmpty(str) {
  console.log(str)
  return (typeof str === 'undefined' || str === null || str === '')
}

// 保留两位小数，不足0补位
export function toDecimal2(x) {
  var f = parseFloat(x)
  if (isNaN(f)) {
    return false
  }
  f = Math.round(x * 100) / 100
  var s = f.toString()
  var rs = s.indexOf('.')
  if (rs < 0) {
    rs = s.length
    s += '.'
  }
  while (s.length <= rs + 2) {
    s += '0'
  }
  return s
}

// 身份证验证
export function isCardNo(certno) {
  certno = certno.toUpperCase()
  var code = certno
  var pass = true
  if (!code || !/^[1-9]{1}[0-9]{14}$|^[1-9]{1}[0-9]{16}([0-9]|[xX])$/.test(code)) {
    pass = false
    return pass
  } else {
    // 18位身份证需要验证最后一位校验位
    if (code.length == 18) {
      code = code.split('')
      // ∑(ai×Wi)(mod 11)
      // 加权因子
      var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
      // 校验位
      var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
      var sum = 0
      var ai = 0
      var wi = 0
      for (var i = 0; i < 17; i++) {
        ai = code[i]
        wi = factor[i]
        sum += ai * wi
      }
      var last = parity[sum % 11]
      if (String(last) !== String(code[code.length - 1])) {
        pass = false
        return pass
      } else {
        return pass
      }
    }
  }
}

// 手机号校验
export function checkPhone(phone) {
  var expr = true
  if (!(/^1[2|3|4|5|6|7|8|9][0-9]{9}$/.test(phone))) {
    return !expr
  } else {
    return expr
  }
}

// 计算年龄,精确到天
export function computedAge(birthday, effectiveDate) {
  var strBirthdayArr = birthday.split('-')
  var strEffectiveDate = effectiveDate.split('-')
  var yearDiff = strEffectiveDate[0] - strBirthdayArr[0]
  var monthDiff = strEffectiveDate[1] - strBirthdayArr[1]
  var dayDiff = strEffectiveDate[2] - strBirthdayArr[2]
  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
    yearDiff -= 1
  }
  return yearDiff
}
// 格式化银行卡号
export function manglingFormatCardNumber(cardNumber) {
  if (cardNumber && cardNumber.length > 8) {
    return `${cardNumber.substring(0, 0)} ${'*'.repeat(cardNumber.length - 4).replace(/(.{4})/g, `$1 `)}${cardNumber.length % 4 ? ' ' : ''}${cardNumber.slice(-4)}`
  }
  return cardNumber
}
// 根据起保日期计算终保日期，精确到天
export function getAfterNYear(startdate, nextYear) {
  var expriedYear = parseInt(startdate.substring(0, 4)) + nextYear
  var expriedMonth = startdate.substring(6, 7)
  var expriedDay = startdate.substring(8)
  // 考虑二月份场景，若N年后的二月份日期大于该年的二月份的最后一天，则取该年二月份最后一天
  if (expriedMonth === '02' || expriedMonth === 2) {
    var monthEndDate = new Date(expriedYear, expriedMonth, 0).getDate()
    if (parseInt(expriedDay) > monthEndDate) { // 为月底时间
      // 取两年后的二月份最后一天
      expriedDay = monthEndDate
    }
  }
  const afterTime = new Date(expriedYear + '-' + expriedMonth + '-' + expriedDay).getTime() - 1000 * 60 * 60 * 24
  const endYear = new Date(afterTime).getFullYear()
  let endMonth = new Date(afterTime).getMonth() + 1
  let endDay = new Date(afterTime).getDate()
  if (endMonth < 10) {
    endMonth = '0' + endMonth
  }
  if (endDay < 10) {
    endDay = '0' + endDay
  }
  return endYear + '-' + endMonth + '-' + endDay
}

// 格式化身份证号
export function formatId(cardId) {
  return cardId.replace(cardId.substr(6, 8), '********')
}
// 起保日期距当前时间
export function checkStartDate(startdate) {
  startdate = new Date(startdate.replace(/-/g, '/'))
  var now = new Date()
  var days = startdate.getTime() - now.getTime()
  var day = parseFloat(days / (1000 * 60 * 60 * 24))
  return day
}
// 邮箱校验
export function checkEmail(emial) {
  if (!(/^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/.test(emial))) {
    return false
  }
}
// 根据身份证号获取性别
export function checkSex(id) {
  var inputStr = id.toString()
  var sex
  if (inputStr.length == 18) {
    sex = inputStr.charAt(16)
    if (sex % 2 == 0) {
      return 2
    } else {
      return 1
    }
  }
}
// 校验邮编
export function checkZipCode(zipCode) {
  var exper = true
  if (!(/^[0-9]{6}$/.test(zipCode))) {
    return !exper
  } else {
    return exper
  }
}

// js 加法
export function plus(num1, num2) {
  var baseNum, baseNum1, baseNum2
  try {
    baseNum1 = num1.toString().split('.')[1].length
  } catch (e) {
    baseNum1 = 0
  }
  try {
    baseNum2 = num2.toString().split('.')[1].length
  } catch (e) {
    baseNum2 = 0
  }
  baseNum = Math.pow(10, Math.max(baseNum1, baseNum2))
  return (num1 * baseNum + num2 * baseNum) / baseNum
}
// js 减法
export function subtract(num1, num2) {
  var baseNum, baseNum1, baseNum2
  try {
    baseNum1 = num1.toString().split('.')[1].length
  } catch (e) {
    baseNum1 = 0
  }
  try {
    baseNum2 = num2.toString().split('.')[1].length
  } catch (e) {
    baseNum2 = 0
  }
  baseNum = Math.pow(10, Math.max(baseNum1, baseNum2))
  return (num1 * baseNum - num2 * baseNum) / baseNum
}

// 身份证获取生日
export function identifyNumberToBirthday(num) {
  return num.substring(6, 10) + '-' + num.substring(10, 12) + '-' + num.substring(12, 14)
}

// js加减乘除运算时失去精度问题解决方法
// js 乘法
export function numMulti(num1, num2) {
  var baseNum = 0
  try {
    baseNum += num1.toString().split('.')[1].length
  } catch (e) {
    console.log(2)
  }
  try {
    baseNum += num2.toString().split('.')[1].length
  } catch (e) {
    console.log(2)
  }
  return Number(num1.toString().replace('.', '')) * Number(num2.toString().replace('.', '')) / Math.pow(10, baseNum)
}
// 除法
export function numDiv(num1, num2) {
  var t1, t2, r1, r2
  try {
    t1 = num1.toString().split('.')[1].length
  } catch (e) {
    t1 = 0
  }
  try {
    t2 = num2.toString().split('.')[1].length
  } catch (e) {
    t2 = 0
  }
  r1 = Number(num1.toString().replace('.', ''))
  r2 = Number(num2.toString().replace('.', ''))
  return (r1 / r2) * Math.pow(10, t2 - t1)
}
export function interpretation(value, text) {
  console.log('ssss', value, text)
  const data = {}
  if (value === 'APP') { // APP进入
    data.terminalId = 'APP'
    data.orderOrigin = text
    data.channelCode = text
    data.projectCode = '200000073708' // ?
  } else if (text === 'ZKICATM') { // 全员营销进入
    data.terminalId = 'H5'
    data.orderOrigin = text
    data.channelCode = text
    data.projectCode = '200000073706'
  } else if (value === 'WD') { // 微店进入
    data.terminalId = 'H5'
    data.orderOrigin = 'DP_WXMP'
    data.channelCode = 'DP_WXMP'
    data.projectCode = '200000073708' // ?
  } else if (value === 'H5') { // 微店进入
    data.terminalId = 'H5'
    data.orderOrigin = text
    data.channelCode = text
    data.projectCode = '200000073708' // ?
  } else { // 官微进入
    data.terminalId = 'H5'
    data.orderOrigin = 'DP_OWXPA'
    data.channelCode = 'DP_OWXPA'
    data.projectCode = '200000073706'
  }
  return {
    terminalId: data.terminalId,
    orderOrigin: data.orderOrigin,
    channelCode: data.channelCode,
    projectCode: data.projectCode
  }
}
export function SolveThrough(value) {
  if (value) {
    const { body } = document
    const scrollTop = document.body.scrollTop || document.documentElement.scrollTop
    body.style.position = 'fixed'
    body.style.width = '100%'
    body.style.top = `-${scrollTop}px`
  } else {
    const { body } = document
    const { top } = body.style
    body.style.position = ''
    body.style.width = ''
    body.style.top = ''
    document.body.scrollTop = -parseInt(top, 10)
    document.documentElement.scrollTop = -parseInt(top, 10)
  }
}

// 检测环境
function checkEnv() {
  const browserName = navigator.userAgent
  if ((/MicroMessenger/i).test(browserName)) {
    return 'H5'
  } else if ((/ZkingCustomerApp/i).test(browserName)) {
    return 'APP'
  }
}

// 去除字符串内所有的空格
function removeSpace(str) {
  const newStr = str.replace(/\s*/g, '')
  return newStr
}

// 各端入口参数处理
function handleURLkey() {
  if (getUrlKey('channelCode')) {
    localStorage.setItem('setChannelCode', getUrlKey('channelCode'))
  }
  if (getUrlKey('terminalId')) {
    localStorage.setItem('setTerminalId', getUrlKey('terminalId'))
  }
  if (getUrlKey('orderId')) {
    localStorage.setItem('setOrderId', getUrlKey('orderId'))
  } else {
    localStorage.removeItem('setOrderId')
  }
  if (getUrlKey('userInfo')) {
    localStorage.setItem('setPersonUserInfo', getUrlKey('userInfo'))
    localStorage.setItem('setUserString', 'B')
  } else {
    localStorage.setItem('setUserString', 'C')
  }
  if (getUrlKey('carMessage')) {
    localStorage.setItem('setCarMessage', getUrlKey('carMessage'))
  }
  if (getUrlKey('salesCode')) {
    localStorage.setItem('setSalesCode', getUrlKey('salesCode'))
  }
  if (getUrlKey('salesName')) {
    localStorage.setItem('setSalesName', getUrlKey('salesName'))
  }
  if (getUrlKey('policyNo')) {
    localStorage.setItem('setPolicyNo', getUrlKey('policyNo'))
  }
}

export function getPhoneLike() {
  const u = navigator.userAgent
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 // g
  if (isAndroid) {
    // 这个是安卓操作系统
    return 'ANDROID'
    // window.addEventListener('resize', this.resizeFn)
  } else {
    return 'IOS'
  }
}

export function generateUUID() {
  let d = new Date().getTime()
  if (window.performance && typeof window.performance.now === 'function') {
    d += performance.now() // use high-precision timer if available
  }
  const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
  })
  return uuid
}

// 隐私脱敏姓名
function hideInsurantName(type, name, frontLen, endLen) {
  if (type === 1) { // 姓名
    let newStr
    if (!name) return ''
    if (name.length === 2) {
      newStr = '*' + name.substr(1, 2)
    } else if (name.length > 2) {
      let char = ''
      for (let i = 0, len = name.length - 2; i < len; i++) {
        char += '*'
      }
      newStr = name.substr(0, 1) + char + name.substr(-1, 1)
    } else {
      newStr = name
    }
    return newStr
  } else if (type === 2) { // 手机号
    if (!name) return ''
    const reg = /^(.{3}).*(.{4})$/
    return name.replace(reg, '$1****$2')
  } else if (type === 3) { // 身份证
    if (!name) return ''
    const reg = /^(.{3}).*(.{4})$/
    return name.replace(reg, '$1***********$2')
  } else if (type === 4) { // 银行卡
    if (!name) return ''
    const reg = /^\d+(\d{4})$/
    return name.replace(reg, '************$1')
  } else if (type === 5) {
    if (!name) return ''
    var chang = name.length - frontLen - endLen
    var xing = ''
    for (var j = 0; j < chang; j++) {
      xing += '*'
    }
    return name.substring(0, frontLen) + xing + name.substring(name.length - endLen)
  }
}

export function downloadFile(fileUrl, token, fileName) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.open('GET', fileUrl, true)
    xhr.setRequestHeader('Authorization', token)
    xhr.responseType = 'blob' // 获取文件blob数据
    xhr.onload = function() {
      if (xhr.status !== 200) {
        return
      }
      const newUrl = window.URL.createObjectURL(xhr.response) // 生成一个可用的临时url
      // const a = document.createElement('a') // 生成a标签调用点击事件
      // a.setAttribute('href', newUrl)
      // a.setAttribute('target', '_blank')
      // a.setAttribute('download', fileName) // 自定义文件名
      // document.body.appendChild(a)
      // a.click()
      // document.body.removeChild(a)
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = newUrl
      link.setAttribute(
        'download',
        fileName
      )
      document.body.appendChild(link)
      link.click()
      window.URL.revokeObjectURL(newUrl)
      resolve('success')
    }
    xhr.send()
    xhr.onerror = (err) => {
      reject(err)
    }
  })
}

export function imgFile(fileUrl) {
  console.log(process.env.API_HOST + fileUrl, 'fileUrl')
  const viewUrl = fileUrl.startsWith('http://') ? fileUrl.replace(/http:\/\//, 'https://') : fileUrl
  return new Promise((resolve, reject) => {
    const request = new XMLHttpRequest()
    request.responseType = 'blob'
    request.open('get', viewUrl, true)
    const token = localStorage.getItem('setToken')
    request.setRequestHeader('Authorization', token)
    request.onreadystatechange = e => {
      if (request.readyState === XMLHttpRequest.DONE && request.status === 200) {
        resolve(URL.createObjectURL(request.response))
        // URL.revokeObjectURL(request.response)
      }
    }
    request.send()
    request.onerror = (err) => {
      reject(err)
    }
  })
}
// 根据身份证号码计算年龄
export const calculateAge = (idCardNumber, data) => {
  console.log(idCardNumber, data, '1')
  // 获取身份证中的出生年、月、日信息
  const birthYear = parseInt(idCardNumber.substring(6, 10))
  const birthMonth = parseInt(idCardNumber.substring(10, 12))
  const birthDay = parseInt(idCardNumber.substring(12, 14))
  console.log(birthYear, birthMonth, birthDay)
  // 获取当前日期的年、月、日信息
  const currentDate = new Date(data)
  console.log(currentDate, 'currentDate')
  const currentYear = currentDate.getFullYear()
  const currentMonth = currentDate.getMonth() + 1
  const currentDay = currentDate.getDate()
  console.log(currentYear, currentMonth, currentDay)
  // 计算年龄
  let age = currentYear - birthYear
  // 当前月份小于出生月份，年龄减1
  if (currentMonth < birthMonth || (currentMonth === birthMonth && currentDay < birthDay)) {
    age--
  }
  return age
}

function checkValidDate(age, data) {
  console.log(data, '什么鬼啊')
  const startNewDate = new Date(data)
  let years = null
  if (age < 16) {
    // 未满16岁，身份证有效期5年
    years = 5
  } else if (age >= 16 && age <= 25) {
    // 16-25岁，身份证有效期10年
    years = 10
  } else if (age >= 26 && age <= 45) {
    // 26-45岁，身份证有效期20年
    years = 20
  } else {
    years = 21
  }
  console.log(years, '年限')
  if (years) {
    if (years > 20) {
      return '9999-12-31'
    } else {
      startNewDate.setFullYear(startNewDate.getFullYear() + years)
      // 检查是否需要调整月份和日期以处理闰年和可能的日期不存在的情况
      // 比如从2月29日加一年，如果这一年不是闰年，则日期应该调整为2月28日
      if (startNewDate.getDate() !== new Date(data).getDate()) {
        startNewDate.setDate(0) // 设置为当前月份的最后一天
      }
      if (startNewDate) {
        const year = startNewDate.getFullYear()
        const month = (startNewDate.getMonth() + 1).toString().padStart(2, '0') // 月份是从0开始的，所以需要+1，并且补全两位数字
        const day = startNewDate.getDate().toString().padStart(2, '0') // 补全两位数字
        console.log(`${year}-${month}-${day}`)
        return `${year}-${month}-${day}`
      }
    }
  }
}
export default {
  imgFile,
  downloadFile,
  interpretation,
  getDate,
  checkPhone,
  getTimeToDate,
  isVehicleNumber,
  isCardNo,
  manglingFormatCardNumber,
  formatId,
  computedAge,
  getAfterNYear,
  checkStartDate,
  checkEmail,
  checkSex,
  toDecimal2,
  checkZipCode,
  plus,
  subtract,
  numMulti,
  numDiv,
  identifyNumberToBirthday,
  SolveThrough,
  getUrlKey,
  isEmpty,
  checkEnv,
  removeSpace,
  handleURLkey,
  getPhoneLike,
  generateUUID,
  hideInsurantName,
  calculateAge,
  checkValidDate
}



// WEBPACK FOOTER //
// ./src/utils/checkFormat.js